export default __webpack_public_path__ + "static/media/classic04.a454e34c.png";